export default "__VITE_ASSET__DTrPy8O0__"